module.exports = __webpack_public_path__ + "media/images/lockup-66a1a4cc0aaa4893c3325702917d6a0d.svg";